export const ALERT_DRAWER_HEADING = "Notifications";

export const NO_ENTRIES_TEXT = "There are currently no notifications!"
export const CLOSE = 'Close';